<div class="input-wrapper">
  @if (leadingIcon()) {
  <app-icon class="input-icon input-icon-leading" [name]="leadingIcon()!" [size]="16" />
  }

  <ng-content></ng-content>

  @if (trailingIcon()) {
  <app-icon class="input-icon input-icon-trailing" [class.hidden]="trailingIconHidden()" [name]="trailingIcon()!"
    [size]="16" (click)="onTrailingIconClick($event)" role="button" tabindex="0" [attr.aria-label]="'Clear'" />
  }
</div>